module.exports = __webpack_public_path__ + "img/포인트.371ac949.png";